import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";

export default function AddBatch() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    course_material: "",
    user: "",
    batch_name: "",
    duration: "",
    timezone: "",
    timings: "",
    batch_starts_at: "",
    mode: "",
    max_students: "",
    venue_address: "",
    is_published: "",
  });

  useEffect(() => {
    const storedId = localStorage.getItem("selectedCourseMaterialId");
    const storedUserId = localStorage.getItem("userId");

    if (!storedId) {
      alert("No course material selected. Please go back and select a course.");
      navigate(-1);
      return;
    }

    if (!storedUserId) {
      alert("User not logged in. Please log in again.");
      navigate("/login");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      course_material: parseInt(storedId, 10),
      user: parseInt(storedUserId, 10),
    }));
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "Yes" : "No") : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formData,
        max_students: formData.max_students
          ? parseInt(formData.max_students, 10)
          : null,
      };

      await AxiosInstance.post(
        "companies/course/batch/",
        payload
      );
      alert("Course batch added successfully!");
      navigate(-1);
    } catch (error) {
      console.error("Failed to add course batch:", error);
      alert("Error adding course batch.");
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      {/* Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div
        className="modal d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="addCourseBatchLabel"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addCourseBatchLabel">
                Add Course Batch
              </h5>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Batch Name</label>
                    <select
                      name="batch_name"
                      className="form-select"
                      value={formData.batch_name}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Batch Name</option>
                      <option value="Morning Batch">Morning Batch</option>
                      <option value="Afternoon Batch">Afternoon Batch</option>
                      <option value="Evening Batch">Evening Batch</option>
                      <option value="Weekdays Batch">Weekdays Batch</option>
                      <option value="Weekend Batch">Weekend Batch</option>
                      <option value="Fast Track Batch">Fast Track Batch</option>
                    </select>
                  </div>

                  <div className="col">
                    <label className="form-label">Duration</label>
                    <input
                      type="text"
                      name="duration"
                      className="form-control"
                      value={formData.duration}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Timezone</label>
                    <select
                      name="timezone"
                      className="form-select"
                      value={formData.timezone}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Time Zone</option>
                      <option value="IST">IST</option>
                      <option value="EST">EST</option>
                      <option value="PST">PST</option>
                      <option value="GMT">GMT</option>
                      <option value="CET">CET</option>
                    </select>
                  </div>

                  <div className="col">
                    <label className="form-label">Timings</label>
                    <input
                      type="text"
                      name="timings"
                      className="form-control"
                      value={formData.timings}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Batch Starts At</label>
                    <input
                      type="date"
                      name="batch_starts_at"
                      className="form-control"
                      value={formData.batch_starts_at}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col">
                    <label className="form-label">Mode</label>
                    <select
                      name="mode"
                      className="form-select"
                      value={formData.mode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Mode</option>
                      <option value="Online">Online</option>
                      <option value="Offline">Offline</option>
                    </select>
                  </div>
                </div>

                {formData.mode === "Offline" && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">Batch Limit</label>
                      <input
                        type="number"
                        name="max_students"
                        className="form-control"
                        value={formData.max_students}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Address</label>
                      <textarea
                        name="venue_address"
                        className="form-control"
                        value={formData.venue_address}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                  </>
                )}

                <div className="mb-3">
                  <label className="form-label">Publish?</label>
                  <select
                    name="is_published"
                    className="form-select"
                    value={formData.is_published}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Publishing Status</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Add Course Batch
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
